export enum SiteView {
  /** The original wedding website (save the date password). */
  Wedding = "Wedding",
  /** The 1 year anniversary celebration page. */
  OneYearAnniversary = "OneYearAnniversary",
}
